<app-header></app-header>

<div class="fluid-container" class="container col-md-12 col-sm-12 col-xs-12 mainContainerStyle" style="background-color: #eeeeee;">
	<!--Loader-->
	<div class="page-loader" *ngIf="loadershow">
		<img src="assets/images/uib-loading-500x500.gif" style="width:100px;">
	</div>

	<!--Left Content-->
	<div class="col-md-7 col-sm-7 col-xs-7 leftContentStyle">

		<!--Application and Date Section-->
		<div class="row" class="leftContentRowStyle">
			<label class="col-md-2 col-xs-2 applicationlabelStyle" style="padding: 0px !important;text-align: center;margin: auto;"><b>Application</b></label>

			<!--Application List Drop Down-->
			<div  class="col-md-5 col-xs-5 applicationListStyle" style="padding-left:0px !important;">
				<select  name="application" [(ngModel)]="selectedApp" class="appSelection shadow" id="application" (change)="selectChangeApplication()"  >
          <option *ngFor="let app of applicationList"  [ngValue]="app" >{{app.name }}</option>
        </select>
			</div>

			<!--Date Range Drop Down-->
			<div class="col-md-5 col-xs-5 dateDropDownStyle">
				<select name="dateRange" class="dateRange shadow" id="dateRange" [(ngModel)]="selectedDateRange" (change)="switchDateRange();">
					<option value="last30">{{ 'Dashboard.last30' | translate }}</option>
					<option value="choosedate">{{ 'Dashboard.dateRange' | translate }}</option>
				</select>
				<div *ngIf="chooseDate" class="dateSelectionDiv">
					<input class="form-control dateSelection" #drp="bsDaterangepicker" bsDaterangepicker [readonly]="true" [maxDate]="bsValue" [(ngModel)]="bsRangeValue" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',rangeInputFormat: 'DD-MM-YYYY' }" (bsValueChange)="selectDates($event)" >
				</div>
			</div>
		</div>

		<!--Period And Channels Section-->
		<div class="showRadioDiv shadow">
			<div class="col-md-6 col-xs-6 period-cls">
				<p class="labelStyle"><b>Period</b></p>
				<div class="periodDivStyle">
					<div *ngIf="radioStatus" class="rangeSelection">
						<input type="radio" class="selectionRange" value="day" [(ngModel)]="selectedPeriod" name="selectionRange" (change)="selectChangePeriod('day')">
						{{ 'Dashboard.day' | translate }}
					</div>
					<div class="rangeSelection">
						<input type="radio" class="selectionRange" value="week" [(ngModel)]="selectedPeriod" name="selectionRange" (change)="selectChangePeriod('week')">
						{{ 'Dashboard.week' | translate }}
					</div>
					<div class="rangeSelection">
						<input type="radio" class="selectionRange" value="month" [(ngModel)]="selectedPeriod" name="selectionRange" (change)="selectChangePeriod('month')">
						{{ 'Dashboard.month' | translate }}
					</div>
				</div>
			</div>

			<div class="col-md-6 col-xs-6 border-cls">
				<p class="labelStyle"><b>Channels</b></p>
				<div *ngIf="selectedApp" class="channelDivStyle grid-container">
					<label *ngFor="let connector of connectors; let i = index;" class="rangeSelection radioButtonDivStyle" style="text-align: left;">
						<input type="radio" class="matBodyRadio" [checked]="i === 0" value="{{connector}}" name="conRadio" (change)="selectChangeChannel(connector)">
							<span style="vertical-align:text-bottom;">&nbsp;{{connector.name}}</span>
					</label>
				</div>
			</div>
		</div>
		<!--Graph Section-->
		<div class="graphLabel">
		<!--Message  Status Section-->
			<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle">{{ 'Dashboard.graphLabelReceived' | translate }}</h5>
			<div class="col-md-12 col-xs-12 showChart" style="margin-bottom:3%;">
				<div *ngIf="noRecords" class="noRecordDiv"><b>{{ 'Dashboard.noData' | translate }}</b></div>
				<img *ngIf="!noRecords && sentChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" width="25px;text-align:center;">
				<div *ngIf="!noRecords" id="chartdiv" class="chartStyle">
				</div>
			</div>
			<!-- waba metrics -->
			<div *ngIf="appName == 'WhatsappOfficial'|| appName == 'WhatsApp Cloud'|| appName == 'WhatsApp Trial'" class="col-md-12 col-xs-12 waba showChart" style="margin-bottom:3%;">
				<!-- <h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" >{{ 'Dashboard.graphLabelWaba' | translate }}</h5>  -->
				<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" ><i class="fa fa-info-circle tooltip" aria-hidden="true">
					<span class="tooltiptext-text">
						<p style="text-align: left;">{{'Dashboard.Marketing' | translate}}</p>
						<p style="text-align: left;">{{'Dashboard.Utility' | translate}}</p>
						<p style="text-align: left;">{{'Dashboard.Authentication' | translate}}</p>
						<p style="text-align: left;">{{'Dashboard.Service' | translate}}</p>
						<p style="text-align: left;">{{'Dashboard.FreeTierConversations' | translate}}</p>
						<p style="text-align: left;">{{'Dashboard.FreeEntryPointConversations' | translate}}</p>
					</span>
				</i> {{ 'Dashboard.graphLabelWaba' | translate }}</h5>
				<div class="col-md-12 col-xs-12 showChart">
				<div *ngIf="noWebaRecords" class="noRecordDiv"><b>{{ 'Dashboard.noData' | translate }}</b></div>
				<img *ngIf="!WebaLoad && wabaChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" width="50px;text-align:center;">
				<div style="padding-left: 20px;padding-bottom: 35px;">
				<button *ngIf="!noWebaRecords" type="button" class="btn btn-primary btn-sm" (click)="wabaDownload = true; templateDownload = false;" style="margin-left: 82%;
				position: absolute; z-index: 100;color: white;font-size: 16px;border-radius: 25px;background: #00b0ff;border:none;height: 35px;padding:0px 9px;" data-toggle="modal" data-target="#downloadModalCenter" >Download</button>
				</div>
				<div *ngIf="!noWebaRecords" id="wabaChartdiv" class="chartStyle" style="height: 600px;"></div>
			   </div>
			</div>

		<!--Message Received Status Section-->
			<!-- <h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" >{{ 'Dashboard.graphLabelReceived' | translate }}</h5>
			<div class="col-md-12 col-xs-12 showChart" style="margin-bottom:3%;">
				<div *ngIf="noRecordsReceived" class="noRecordDiv"><b>{{ 'Dashboard.noData' | translate }}</b></div>
				<img *ngIf="!noRecordsReceived && receivedChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" width="25px;text-align:center;">
				<div *ngIf="!noRecordsReceived" id="chartdivReceived" class="chartStyle"></div>
			</div> -->

		<!--Message Template Section-->
		<!-- <div *ngIf="appName == 'WhatsappOfficial'">
			<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" >{{ 'Dashboard.graphLabelTemplate' | translate }}</h5>
			<div class="col-md-12 col-xs-12 showChart">
				<div *ngIf="noTemplateRecordsReceived" class="noRecordDiv"><b>{{ 'Dashboard.noData' | translate }}</b></div>
				<img *ngIf="!noTemplateRecordsReceived && templateChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" width="25px;text-align:center;">
				<button *ngIf="!noTemplateRecordsReceived" type="button" class="btn btn-primary btn-sm" (click)="templateDownload = true; wabaDownload = false;" style="margin-left: 82%;
				margin-top: 2%;
				position: absolute; z-index: 100;color: white;font-size: 16px;border-radius: 25px;background: #00b0ff;border:none;height: 35px;padding:0px 9px;" data-toggle="modal" data-target="#downloadModalCenter" >Download</button>
				<div *ngIf="!noTemplateRecordsReceived" id="chartdivTemplate" class="chartStyle"></div>
			</div>
		</div> -->

            <!-- <div *ngIf="appName == 'WhatsappOfficial'">
			<h5 class="col-md-12 col-xs-12 switchTabHeaderStyle" >Template Message Delivered  Status</h5>
			<div class="col-md-12 col-xs-12 showChart">
				<div *ngIf="noTemplateDeliveredRecordsReceived" class="noRecordDiv"><b>{{ 'Dashboard.noData' | translate }}</b></div>
				<img *ngIf="!noTemplateDeliveredRecordsReceived && templateDeliveredChartOptions.dataProvider.length == 0" src="assets/images/uib-loading-500x500.gif" width="25px;text-align:center;">
				<div *ngIf="!noTemplateDeliveredRecordsReceived" id="chartdivTemplateDelivered" class="chartStyle"></div>
			</div>
		</div> -->

		</div>
	</div>

	<!--Right Content-->
	<div class="col-md-5 col-sm-5 col-xs-5 chartsData rightContentStyle">
		<!--Tab Switch Section-->
		<div class="tabSelectionDivStyle col-md-12 col-sm-12 col-xs-12">
			<button type="button" style="margin-right:1%;" class="col-md-6 col-sm-6 col-xs-6 btn btn-default tabButtonStyle" [ngClass]="{'activeTab' : showMessageSentStatus}" (click)="switchTab()">
				{{'Message Sent Status ' | translate}} <br> (All Channels)
			</button>
			<button type="button" class="col-md-6 col-sm-6 col-xs-6 btn btn-default tabButtonStyle" [ngClass]="{'activeTab' : showMessageReceivedStatus}" (click)="switchTab()">
				{{'Message Received Status' | translate}} <br> (All Channels)
			</button>
		</div>

		<!--Message Sent Status Count Section-->
		<div *ngIf="showMessageSentStatus" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px !important;">

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Messages sent in last 30 days' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{last30DaysFromDate | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{last30DaysToDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalDateCountLoader" class="tabCountContentStyle">{{totalDateCount | number:'1.'}}</label>
					<img *ngIf="totalDateCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle" style="font-weight:700;">
					{{ 'Dashboard.chartDataTotal' | translate }}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalSentMessageLoader" class="tabCountContentStyle">{{totalSentMessages | number:'1.'}}</label>
					<img *ngIf="totalSentMessageLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataToday' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{todaysDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!todaysCountLoader" class="tabCountContentStyle">{{todaysCount | number:'1.'}}</label>
					<img *ngIf="todaysCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataWeek' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentWeekStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentWeekEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!weeklyCountLoader" class="tabCountContentStyle">{{weeklyCount | number:'1.'}}</label>
					<img *ngIf="weeklyCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataMonth' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentMonthStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentMonthEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!monthlyCountLoader" class="tabCountContentStyle">{{monthlyCount | number:'1.'}}</label>
					<img *ngIf="monthlyCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataYear' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentYearStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentYearEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!yearlyCountLoader" class="tabCountContentStyle">{{yearlyCount | number:'1.'}}</label>
					<img *ngIf="yearlyCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle"  *ngIf="renewalDate !== 'undefined'">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataSentRenewed' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{renewalDate | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{todaysDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!sentRenewCountLoader" class="tabCountContentStyle">{{sentRenewedCount | number:'1.'}}</label>
					<img *ngIf="sentRenewCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="(selectedConnector && selectedConnector.name !== null && selectedConnector.name !== '' && selectedConnector.name !== undefined)">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataTotalMsgConnector' | translate }} {{this.selectedConnector.name}}</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalCountByConnectorsLoader" class="tabCountContentStyle">{{totalCountByConnectors | number:'1.'}}</label>
					<img *ngIf="totalCountByConnectorsLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="selectedConnector && selectedConnector.hasHsm" style="margin-bottom: 0% !important;">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataHsm' | translate }}</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!hsmCountByConnectorsLoader" class="tabCountContentStyle">{{hsmCountByConnectors | number:'1.'}}</label>
					<img *ngIf="hsmCountByConnectorsLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>
		</div>

		<!--Message Received Status Count Section-->
		<div *ngIf="showMessageReceivedStatus" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px !important;">

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Messages received in last 30 days' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{last30DaysFromDate | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{last30DaysToDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalReceivedDateCountLoader" class="tabCountContentStyle">{{totalReceivedDateCount | number:'1.'}}</label>
					<img *ngIf="totalReceivedDateCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle" style="font-weight:700;">
					{{ 'Dashboard.chartDataTotalReceived' | translate }}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalReceivedMessageLoader" class="tabCountContentStyle">{{totalReceivedMessages | number:'1.'}}</label>
					<img *ngIf="totalReceivedMessageLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataToday' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{todaysDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!todaysReceivedCountLoader" class="tabCountContentStyle">{{todaysReceivedCount | number:'1.'}}</label>
					<img *ngIf="todaysReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataWeek' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentWeekStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentWeekEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!weeklyReceivedCountLoader" class="tabCountContentStyle">{{weeklyReceivedCount | number:'1.'}}</label>
					<img *ngIf="weeklyReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataMonth' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentMonthStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentMonthEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!monthlyReceivedCountLoader" class="tabCountContentStyle">{{monthlyReceivedCount | number:'1.'}}</label>
					<img *ngIf="monthlyReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataYear' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{currentYearStarts | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{currentYearEnds | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!yearlyReceivedCountLoader" class="tabCountContentStyle">{{yearlyReceivedCount | number:'1.'}}</label>
					<img *ngIf="yearlyReceivedCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="renewalDate !== 'undefined'">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataReceivedRenewed' | translate }}</div>
				<div class="col-md-12 col-sm-12 col-xs-12 btn tabDateStyle">
					{{renewalDate | date : 'yyyy-MM-dd'}} &nbsp;&nbsp;&nbsp; <span class="dateSpanStyle"> TO </span> &nbsp;&nbsp;&nbsp; {{todaysDate | date : 'yyyy-MM-dd'}}
				</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!receivedRenewCountLoader" class="tabCountContentStyle">{{receivedRenewedCount | number:'1.'}}</label>
					<img *ngIf="receivedRenewCountLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>

			<div class="shadow tabStyle" *ngIf="(selectedConnector && selectedConnector.name !== null && selectedConnector.name !== '' && selectedConnector.name !== undefined)">
				<div class="tabHeaderStyle">{{ 'Dashboard.chartDataTotalReceivedMsg' | translate }} {{this.selectedConnector.name}}</div>
				<div class="col-md-5 col-sm-5 col-xs-5 btn tabButtonStyle">
					<label *ngIf="!totalReceivedCountByConnectorsLoader" class="tabCountContentStyle">{{totalReceivedCountByConnectors | number:'1.'}}</label>
					<img *ngIf="totalReceivedCountByConnectorsLoader" src="assets/images/uib-loading-500x500.gif" width="25px">
				</div>
			</div>
		</div>
	</div>
</div>
<!-- Modal for Download -->
<div class="modal fade" id="downloadModalCenter" tabindex="-1" role="dialog" aria-labelledby="downloadModalCenterTitle" aria-hidden="true" >
	<div class="modal-dialog modal-dialog-centered" role="document">
	  <div class="modal-content">
		<div class="modal-header">
			<h2 *ngIf="templateDownload" style="text-align: center;font-size: 25px;margin-left: 17%;margin-top: 2%;margin-bottom: 2%;">Template usage report</h2>
			<h2 *ngIf="wabaDownload" style="text-align: center;font-size: 25px;margin-left: 17%;margin-top: 2%;margin-bottom: 2%;">WhatsApp usage report</h2>
		  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		  </button>
		</div>
		<div class="modal-body" style="background-color: #eee">
		  <div >
			  <div  class="text-center">
				<div class="row col-sm-12" style="margin-bottom: 10px;">
					<div class="col-md-6">
						<div class="pt-1" style="text-align:left">Select your option: </div>
					</div>
					<div class="col-md-6">
						<select class="form-control" [(ngModel)]="dateType">
							<option value="day">Day</option>
							<option value="month">Month</option>
						</select>
					</div>
				</div>
				<div class="row col-sm-12" *ngIf="dateType == 'day'">
					<div class="col-md-6">
						<div class="pt-1" style="text-align:left">Select the date: </div>
					</div>
					<div class="col-md-6">
						<input class="form-control" bsDatepicker [readonly]="true" [maxDate]="bsValue1" [(ngModel)]="downLoadDate" [bsConfig]="{ adaptivePosition: true,containerClass: 'theme-default',dateInputFormat: 'DD/MM/YYYY' }"  >
					</div>
				</div>
				<div class="row col-sm-12" *ngIf="dateType == 'month'">
					<div class="col-md-6">
						<div class="pt-1" style="text-align:left">Select the month: </div>
					</div>
					<div class="col-md-6">
						<input class="form-control" bsDatepicker [readonly]="true" [maxDate]="bsValueMonth" [(ngModel)]="downLoadMonth" [bsConfig]="{ minMode:'month',adaptivePosition: true,containerClass: 'theme-default',dateInputFormat: 'MM/YYYY'}" >
					</div>
				</div>
				<div *ngIf="templateDownload" class="pt-3"> <button type="button" style="color: white;font-size: 16px;border-radius: 25px;background: #00b0ff;border:none;height: 35px;" class="btn btn-primary " (click)="downloadTemplateCount()">Download</button></div>
				<div *ngIf="wabaDownload" class="pt-3"> <button type="button" style="color: white;font-size: 16px;border-radius: 25px;background: #00b0ff;border:none;height: 35px;" class="btn btn-primary " (click)="downloadWabaCount()">Download</button></div>
			</div>

		  </div>
		</div>
		<div class="modal-footer" style="height: 70px;">

		</div>
	  </div>
	</div>
  </div>
<app-footer></app-footer>
